<template>
    <div class="wrapper">
        <el-container :class="{ 'center-container': screenWidth > 1920 }">

            <el-header class="header">
                <div class="header-left" @click="toHome()">
                    <div class="logo-div">
                        <img src="@/assets/images/head_logo.png" alt="" class="logo ">
                    </div>
                </div>
                <div class="logo-center">
                    <ul class="notice-list" :style="`animation-duration: 60s;`">
                        <li v-for="(item, index) in luckyUsers" :key="index">{{ item }}</li>
                        <li v-for="(item, index) in luckyUsers" :key="index+'copy'">{{ item }}</li>
                    </ul>
                </div>
                <!-- <div class="logo-center">

                    <img src="@/assets/images/head_center.png" alt="" class="hngj_head">

                </div> -->
                <!-- <div class="dept">
                    <el-select v-model="deptId" placeholder="请选择部门" clearable style="width: 100px;margin-right:10px"
                        @change="changeDept">
                        <el-option v-for="(item,index) in deptList" :key="index" :label="item.dept_name"
                            :value="item.dept_id" />
                    </el-select>
                </div> -->
                <div class="header-right">
                    <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
                        <div class="avatar-wrapper">
                            <div class="user-avatar"><el-avatar :src="store.getters.avatar"
                                    @click.prevent="toCreativeSpace('创意空间')" /></div>
                            <span class="name-span">{{store.getters.userInfo.nickName}}</span>
                            <el-icon class="drop">
                                <caret-bottom color="#333" />
                            </el-icon>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="center">个人中心</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <div class="logout" @click.prevent="logout">
                        <img src="@/assets/images/exits.png" alt="">
                        <span style="vertical-align: middle;">退出登录</span>
                    </div>
                </div>
            </el-header>

            <el-container>

                <el-main>
                    <el-collapse-transition>
                        <router-view></router-view>
                    </el-collapse-transition>
                </el-main>
            </el-container>
            <el-dialog v-model="dialogPwdVisible" title="修改密码" display="block" width="35%" :show-close="false"
                :center="true" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
                <div class="pass-title">
                    {{firstLogin?'首次登录需要修改密码':'您已经超过90天未修改密码'}}，请立即修改密码！
                </div>
                <el-form :model="passForm" ref="pd" :rules="passwordRules" style="width:95%">
                    <el-form-item label="&nbsp;&nbsp;&nbsp;新密码" prop="newPassword">
                        <div style="display:flex;align-items:center;width:100%">
                            <el-input type="password" v-model="passForm.newPassword" style="flex-shrink:0" />
                            <el-tooltip effect="dark" content="密码长度大于8位,且不能有空格,包含字母、数字和特殊字符" placement="top-start">
                                <el-icon class="tips">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                        </div>

                    </el-form-item>

                    <el-form-item label="确认密码" prop="newPasswordCopy">
                        <el-input type="password" v-model="passForm.newPasswordCopy" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button type="primary" @click="firstUpdatePassword()">确认</el-button>
                    </span>
                </template>
            </el-dialog>

            <Footer></Footer>
        </el-container>
        <el-dialog title="个人中心" v-model="dialogVisible" display="block" width="50%" :center="true"
            :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
            <PerSonal />
        </el-dialog>

    </div>
</template>
<script setup>
    import PerSonal from "@/views/portal/creativeSpace/personalCenter.vue";
    import { ElMessageBox, ElMessage } from "element-plus";
    import store from "@/store";
    import Footer from "@/layout/components/footer/index.vue";
    import { computed, onMounted, reactive, ref, watch } from "vue";
    import { useRouter } from "vue-router";
    import {
        updateEmail,
        updatePassword,
        updateEmailByPortal,
        updatePasswordByPortal,
        getUserDeptList,
        switchDept,
    } from "@/api/system/user.js";
    import { getEpidList } from "@/api/portal/epid.js";
    import { ArrowRight } from "@element-plus/icons-vue";
    import { queryByInit } from "@/api/portal/theme";
    const luckyUsers = ref([
        "以铁的信念、铁的纪律、铁的作风、铁的担当，打造一流铁军！",
        "以铁的信念、铁的纪律、铁的作风、铁的担当，打造一流铁军！",
        "以铁的信念、铁的纪律、铁的作风、铁的担当，打造一流铁军！",
        "以铁的信念、铁的纪律、铁的作风、铁的担当，打造一流铁军！",
    ]);
    const userInfo = store.getters.userInfo;
    const modifyPasswd = store.getters.modifyPasswd;
    const firstLogin = store.getters.firstLogin;
    const deptList = ref([]);
    const deptId = ref("");
    const passForm = ref({
        newPassWord: "",
        newPasswordCopy: "",
    });
    const dialogPwdVisible = ref(false);

    const currentPath = ref(null);
    const { proxy } = getCurrentInstance();
    const portal_theme_background_img_dragon = computed(() => store.state.portalSettings.backgroundImg);
    const portal_title = computed(() => store.state.portalSettings.portalTitle);
    const portal_header = computed(() => store.state.portalSettings.portalHeader);
    const portal_title_bak_color = computed(() => store.state.portalSettings.portalTitleBakColor);
    const portal_nav_bak_color = computed(() => {
        return store.state.portalSettings.portalNavBakColor;
    });

    const portal_logo = computed(() => {
        return store.state.portalSettings.portalLogo;
    });
    const portal_user_detail = computed(() => store.state.portalSettings.portalUserDetail);

    const dialogVisible = ref(false);

    const appToolbarShow = ref(true);
    const clientList = ref([]);
    const clientPrefix = "clientId:";
    const toolbarList = reactive([
        { name: "首页", path: "/portal/workbench", active: true },
        { name: "新闻中心", path: "/portal/portalHome", active: false },

        { name: "应用中心", path: "/portal/applicationCenter", active: false },
        { name: "个人中心", path: "/portal/creativeSpace", active: false },
    ]);
    const passwordRules = ref({
        newPassword: [
            { required: true, trigger: "blur", message: "密码不能为空" },

            {
                required: true,
                validator: (rule, value, callback) => {
                    const str = /^((?=\S*?[A-z])(?=\S*?[0-9])(?=.*[!@#$%^&*]).{8,})\S$/;
                    if (str.test(value)) {
                        callback();
                    } else {
                        callback("密码长度大于8位,且不能有空格,包含字母、数字和特殊字符");
                    }
                },
                trigger: "blur",
            },
        ],
        newPasswordCopy: [
            { required: true, trigger: "blur", message: "密码不能为空" },
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (passForm.value.newPassword !== value) {
                        callback(new Error("输入的密码不一致"));
                    } else {
                        callback();
                    }
                },
                trigger: "blur",
            },
        ],
    });
    const router = useRouter();
    const input = ref("");
    const handleToolbarClick = (tb) => {
        if (tb.type === "yj") {
            window.open("http://bbs.eathink.com.cn/superGeek/1?plate=4");
        } else if (tb.type === "zszx") {
            window.open("https://yxjt.eathink.com.cn:9443/sso");
        } else if (tb.type === "nl") {
            window.open("http://products.eathink.com.cn:7080/");
        } else {
            // 判断常用系统是否显示
            showAppToolbar(tb.path);
            toolbarList.map((tbItem) => {
                tbItem.active = false;
                if (tbItem.path === tb.path && tbItem.name === tb.name) {
                    tbItem.active = true;
                }
            });
            router.push(tb.path);
        }
    };
    //    判断密码是否是原始密码
    //  function judge(){
    //        if(userInfo.sysUserEx.passFlag=='0'){
    //            dialogVisible.value=true
    //        }
    //  }
    //  judge();

    function firstUpdatePassword() {
        proxy.$refs.pd.validate((valid) => {
            if (valid) {
                updatePassword({
                    userId: userInfo.userId,
                    userName: userInfo.userName,
                    newPassword: passForm.value.newPassword,
                }).then((res) => {
                    if (res) {
                        proxy.$message({
                            message: "修改成功!",
                            type: "success",
                        });
                        dialogVisible.value = false;
                        logoutFirst();
                    } else {
                        proxy.$message({
                            message: "修改失败，请重新输入!",
                            type: "error",
                        });
                    }
                });
            }
        });
    }
    const screenWidth = ref(document.body.clientWidth);
    watch(screenWidth, (n, o) => {
        console.log("当前页面宽度为:" + n + "px");
    });

    onMounted(() => {
        window.onresize = () =>
            (() => {
                screenWidth.value = document.body.clientWidth;
            })();

        currentPath.value = router.currentRoute.value.path;

        showAppToolbar(currentPath.value);
        toolbarList.map((tbItem) => {
            tbItem.active = false;
            if (tbItem.path === currentPath.value) {
                tbItem.active = true;
            }
        });

        // 获取应用中心
        clientList.value = store.getters.clientList;
        if (modifyPasswd || firstLogin) {
            dialogPwdVisible.value = true;
        }
    });
    function viewNews(url) {
        window.open(url);
    }
    function toHome() {
        router.push("/portal/workbench");
    }
    function riskInquiry() {
        window.open("http://bmfw.www.gov.cn/yqfxdjcx/index.html");
    }
    function travelPolicy() {
        window.open(
            "https://a2j1a3.smartapps.cn/doctor/pages/epidemic/index/index?footer=%20&title=%E5%90%84%E5%9C%B0%E9%98%B2%E6%8E%A7%E6%94%BF%E7%AD%96&id=14"
        );
    }

    function logoutFirst() {
        store.dispatch("SSOLogOut").then(() => {
            location.href = "/login";
        });
    }
    function logout() {
        ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            confirmButtonClass: "btnConfirm",
            type: "warning",
        })
            .then(() => {
                store.dispatch("SSOLogOut").then(() => {
                    location.href = "/login";
                });
            })
            .catch(() => {});
    }
    // 判断常用系统是否显示
    function showAppToolbar(path) {
        if (path === "/portal/applicationCenter") {
            appToolbarShow.value = false;
        } else {
            appToolbarShow.value = true;
        }
    }

    /**
     * 点击client触发的事件
     */
    const clientClickHandler = (item) => {
        // 记录ID被点击的次数
        incrementClientCount(item.clientId);
        window.open(item.webServerRedirectUri);
    };
    const getClientCount = (clientId) => {
        return localStorage.getItem(clientPrefix + clientId);
    };
    const incrementClientCount = (clientId) => {
        const clientCount = getClientCount(clientId);
        if (clientCount) {
            localStorage.setItem(clientPrefix + clientId, Number(clientCount) + 1);
        } else {
            localStorage.setItem(clientPrefix + clientId, 1);
        }
    };
    //跳转个人空间
    function toCreativeSpace(tabName) {
        handleToolbarClick(toolbarList.filter((item) => item.name == tabName)[0]);
    } //加载皮肤
    queryByInit().then((res) => {
        localStorage.setItem("portal-setting", JSON.stringify(res.themeConfig));
        const portalSetting = JSON.parse(res.themeConfig);
        store.state.portalSettings.backgroundImg = portalSetting.backgroundImg;

        store.state.portalSettings.portalColor = { color: "#4374e5" };
        store.state.portalSettings.portalNavBakColor = { background: "#fff" };
        store.state.portalSettings.mainColor = { color: "#4979E5" };
        store.state.portalSettings.hoverMainColor = { background: "#EDF2FF" };
        store.state.portalSettings.MainOpacityColor = { color: "#cee6ff" };

        store.state.portalSettings.portalHeader = portalSetting.portalHeader;
        store.state.portalSettings.portalHeader = portalSetting.portalHeader;
        store.state.portalSettings.portalTitleBakColor = portalSetting.portalTitleBakColor;

        store.state.portalSettings.contentBakColor = portalSetting.contentBakColor;
        store.state.portalSettings.portalLogo = portalSetting.portalLogo;
        store.state.portalSettings.portalUserDetail = portalSetting.portalUserDetail;
    });

    function handleCommand(command) {
        switch (command) {
            case "center":
                router.push("/portal/creativeSpace");
                break;
            case "logout":
                logout();
                break;
            default:
                break;
        }
    }
    //获取用户所在部门列表
    function getList() {
        getUserDeptList(userInfo.userId).then((res) => {
            deptList.value = res;
            const items = deptList.value.find((item) => item.main_dept == "主职部门");
            deptId.value = items.dept_id;
        });
    }
    // getList();
    function changeDept(value) {
        switchDept(userInfo.userId, value).then((res) => {
            proxy.$message({
                message: "切换用户部门成功!",
                type: "success",
            });
        });
    }
</script>


<style>
    .popper-class {
        background: rgba(0, 0, 0, 0) !important;
        border: 0px !important;
        padding: 0px !important;
    }
</style>

<style lang='scss' scoped>
    .logo {
        height: 45px;
        width: auto;
        margin-right: 15px;
    }
    .logo-name {
        height: 32px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .wrapper {
        background: #4979e51a;
    }
    .el-container {
        position: relative;
        overflow: hidden;
        max-width: 1920px;
        height: 100vh;
    }

    .popper-class {
        padding: 0px;
    }

    .center-container {
        left: 50%;
        margin-left: -960px;
    }

    /**    header  begin */
    .header {
        height: 84px;
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        /* 中性色/1 white */
        z-index: 1;
        // color: #FFFFFF;
        // background: none !important;
        padding: 0 32px;
        background: url("@/assets/images/head_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .header .header-left {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        cursor: pointer;
    }

    .header .toolbar {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        list-style: none;
        margin-left: 100px;
        padding-left: 0;
        font-weight: 600;
        margin-left: 60px;
        margin-top: 0;
        margin-bottom: 0;
    }
    .header .toolbar li {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        list-style: none;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        letter-spacing: 0.8px;
        color: #fff;
        margin-right: 70px;
        height: 114px;
        line-height: 114px;
        min-width: 124px;
    }

    .search {
        --el-border-radius-base: 16px;
    }

    .header .header-right {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .header .header-right .weather {
        // display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: row;
        padding-top: 25px;
        pointer-events: none;
    }
    .header .header-right .weather span {
        margin: 0 20px;
    }
    /**     header  end **/

    .el-aside {
        width: 400px;
        padding: 40px 0;
        margin: 20px 0 30px 32px;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 16px;
    }

    .info {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .info .avatar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    .el-icon {
        vertical-align: middle;
        font-size: 10px;
    }
    .info .welcome {
        font-weight: 600;
        color: rgb(29, 28, 28);
    }
    .shortcut {
        display: -webkit-flex; /* Safari */
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        // align-items: center;
        text-align: center;
        padding: 20px 20px 0;
    }

    .shortcut .item {
        display: -webkit-flex; /* Safari */
        display: flex;
        flex-direction: column;
        // margin: 7px 0 20px;
        padding: 16px 0;
        margin: 0 3% 20px;
        width: 26%;

        cursor: pointer;
        text-align: center;
        &:hover {
            background: rgba(237, 242, 255, 0.5);
            border-radius: 8px;
        }
    }
    .item:hover > .main-text {
        color: #4374e5;
    }
    .shortcut .item img {
        width: 56px;
        height: 56px;
    }
    .shortcut .item span {
        text-align: center;
        color: #595959;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0;
    }
    .footer {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: flex-end;
        flex-direction: row;
        align-items: center;
    }
    .footer span {
        margin-right: 10px;
    }
    .logout {
        font-size: 18px;
        letter-spacing: 0.49px;
        cursor: pointer;
        color: #333;
    }
    .logout img {
        width: 18px;
        vertical-align: middle;
        margin-right: 8px;
    }
    .username {
        padding: 12px 0;
        font-size: 20px;
        color: #4374e5;
        letter-spacing: 0.62px;
        font-weight: 500;
    }
    .job-num {
        padding: 8px 20px;
        background: #ffffff;
        border-radius: 16px;
        font-size: 16px;
        line-height: 16px;
        color: #6d7278;
        letter-spacing: 0.49px;
        font-weight: 500;
        .line {
            line-height: 16px;
            padding: 0 10px;
            color: rgba(109, 114, 120, 0.2);
        }
    }
    .logo-div {
        display: flex;
        align-items: center;
    }
    .name {
        margin-bottom: 7px;
        font-size: 26px;
        letter-spacing: 0.8px;
        font-weight: 700;
        color: #333;
    }

    .user-avatar img {
        width: 28px;
        height: 28px;
    }
    .name-span {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        padding: 0 10px;
    }
    .avatar-wrapper {
        display: flex;
        align-items: center;
    }
    .right-menu-item {
        margin-right: 40px;
        cursor: pointer;
    }
    .drop {
        font-size: 24px;
    }
    .logo-center {
        height: 45px;
        img {
            height: 100%;
            width: auto;
        }
        .hngj_head {
            margin-top: 6px;
            height: 24px;
            width: auto;
        }
    }
    .logo-center {
        width: 38%; //容器定宽高
        height: 30px;
        margin: 0 auto;
        font-size: 26px;
        line-height: 30px;
        overflow: hidden; //超出内容隐藏
        color: #000;
        .notice-list {
            width: fit-content; // Q1
            white-space: nowrap; // 内容不换行
            animation-name: seamless-scrolling; // Q3
            animation-timing-function: linear; // 动画速度曲线，匀速
            animation-iteration-count: infinite; // 动画循环无限次播放
            height: 30px;
            line-height: 30px;
            margin: 0;
            li {
                display: inline-block;
                margin-right: 150px;
                letter-spacing: 2px;
                height: 30px;
                line-height: 30px;
            }
        }
    }

    @keyframes seamless-scrolling {
        0% {
            transform: translateX(0px);
        }
        100% {
            transform: translateX(-50%); //Q2
        }
    }
    .pass-title {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;

        display: flex;
        align-items: center;

        /* 中性色/0.85 标题 */

        color: #262626;

        /* Inside auto layout */

        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;

        margin-bottom: 30px;
    }
    .tips {
        margin-left: 10px;
        font-size: 18px;
        color: red;
        // position: absolute;
        // top: -2px;
        // right: -2px;
        cursor: pointer;
    }
</style>
<style>
    .el-badge__content {
        border: 0;
    }
    .el-main {
        overflow: hidden;
        padding: 20px 20px 0px 30px;
    }
    html::-webkit-scrollbar {
        width: 0 !important;
    }
    el-main::-webkit-scrollbar {
        width: 0 !important;
    }
    .image-wh {
        width: 60px;
        height: 60px;
        /* box-shadow: 0px 4px 8px 0px rgba(81, 184, 53, 0.15); */
        /* border-radius: 8px; */
        margin: 0px auto;
    }
    .image-wh-error {
        width: 60px;
        height: 60px;
        border-radius: 8px;
    }
    .btnConfirm {
        background: #4979e5 !important;
        border: none;
    }
    .el-dropdown-menu__item {
        font-size: 16px !important;
    }
    .header-right .el-dropdown-menu__item:not(.is-disabled):focus {
        background-color: #fde2e2 !important;
        color: #4979e5 !important;
    }
</style>
